export var IconName;
(function (IconName) {
    IconName["Check"] = "check";
    IconName["Cross"] = "cross";
    IconName["Reveal"] = "reveal";
    IconName["ArrowLeft"] = "left";
    IconName["ArrowRight"] = "right";
    IconName["DoubleArrowRight"] = "doubleArrowRight";
    IconName["List"] = "list";
    IconName["Menu"] = "menu";
})(IconName || (IconName = {}));
export var IconPosition;
(function (IconPosition) {
    IconPosition["TopLeft"] = "TL";
    IconPosition["TopRight"] = "TR";
    IconPosition["BottomLeft"] = "BL";
    IconPosition["BottomRight"] = "BR";
    IconPosition["Center"] = "Center";
})(IconPosition || (IconPosition = {}));
export const iconSize = 24;
//# sourceMappingURL=IconShared.js.map